/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hotel_Nav_LabelInputs */

const en_hotel_nav_label = /** @type {(inputs: Hotel_Nav_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Main navigation`)
};

/**
* | output |
* | --- |
* | "Main navigation" |
*
* @param {Hotel_Nav_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const hotel_nav_label = /** @type {((inputs?: Hotel_Nav_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hotel_Nav_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_hotel_nav_label(inputs)
});
export { hotel_nav_label as "hotel.nav_label" }